/* eslint-disable prefer-destructuring */
import ServerData from '../../data/server';

function getBaseUrl() {
  const { hostname } = window.location;
  const url = ServerData[hostname];
  if (url) return url;
  return ServerData.localhost;
}

function getUrlHostname(url = '') {
  let hostname;

  if (url.indexOf('//') > -1) {
    hostname = url.split('/')[2];
  } else {
    hostname = url.split('/')[0];
  }

  hostname = hostname.split(':')[0];
  hostname = hostname.split('?')[0];

  return hostname;
}

function checkSameHostname(url) {
  if (getUrlHostname(url) === window.location.hostname) return true;
  return false;
}

export default {
  getBaseUrl,
  getUrlHostname,
  checkSameHostname,
};
